import { createContext, useContext } from "react";
type CompanySettings = {
  currency: string;
  timezone?: string;
};
const CompanySettingsContext = createContext<CompanySettings | undefined>(undefined);
export function useCompanySettings() {
  const context = useContext(CompanySettingsContext);
  if (context === undefined) {
    throw new Error("useCompanySettings must be used within a CompanySettingsProvider");
  }
  return context;
}
export function CompanySettingsProvider({
  children,
  settings
}: {
  children: React.ReactNode;
  settings: CompanySettings;
}) {
  return <CompanySettingsContext.Provider value={settings} data-sentry-element="unknown" data-sentry-component="CompanySettingsProvider" data-sentry-source-file="company-settings-context.tsx">
      {children}
    </CompanySettingsContext.Provider>;
}